import { testimonials } from '@/mocks/siteContent';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-secondary-900">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10">
          <span className="text-xs md:text-sm label-font text-accent-400 tracking-[0.2em]">
            READERS
          </span>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-background-50">
            读过合集的人怎么说
          </h2>
          <p className="mt-3 text-sm md:text-base text-secondary-200">
            来自不同阅读习惯的反馈，也是我们持续整理时间线的动力。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="p-5 md:p-6 rounded-lg bg-secondary-800 border border-secondary-700 flex flex-col"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
              <blockquote className="mt-3 text-sm text-secondary-100 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-secondary-700 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-accent-950 font-heading font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-background-50 label-font">
                    {item.name}
                  </span>
                  <span className="block text-xs text-secondary-300 label-font">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}